import Timeout from '../lib/Timeout.js';
import Promise from '../lib/Promise.js';

class MaintenanceTask {
    static run(params) {
        return new MaintenanceTask(params).run();
    }

    constructor({env}) {
        this.env = env;
    }

    reloadInOneMinute() {
        Timeout.seconds(60).then(() => this.env.reloadPage());
    }

    run() {
        var maintenanceWindow = this.env.getMaintenanceWindow();

        if (this.env.isLoginDown()) {
            this.env.showDialog('maintenance-done-momentarily-dialog');
            this.reloadInOneMinute();

            return Promise.inert();
        }
        else if (maintenanceWindow.didStart()) {
            this.env.showDialog('maintenance-done-within-two-hours-dialog');
            this.reloadInOneMinute();

            return Promise.inert();
        }
        else if (maintenanceWindow.startsWithinFourHours()) {
            return this.env.getDialog('pending-maintenance-dialog')
                .setMsToStartTime(maintenanceWindow.getMsToStartTime())
                .show();
        }

        return Promise.resolve();
    }
}

export default MaintenanceTask;